import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { sizeFilter, handleHttp, transformStr3, getformListItemsdatas, formatToLine, formfileHandle, getdefaultVal, getFileStatus, getformatstruct } from "@/utils/utils";
export default {
  name: 'mapdata',
  props: ['mtObj', 'ispc'],
  data() {
    return {
      structList: [],
      // 表单结构集合
      sList: [],
      // 表单结构格式化集合
      form: {},
      // 表单form
      formlabel: {},
      // 表单字段名称
      formoption: {},
      dfileList: {},
      // 默认上传文件集合
      fileList: {},
      // 默认上传文件集合
      cfname: '',
      // 当前上传文件字段名称
      leveloptions: [],
      currentformuser: {},
      isAddOrEdit: true,
      jsonOption: {},
      popOption: [{
        imgPath: '',
        title: '模板1',
        id: 0
      }, {
        imgPath: '',
        title: '模板2',
        id: 0
      }, {
        imgPath: '',
        title: '模板3',
        id: 0
      }],
      typeOption: [{
        imgPath: '',
        title: '模板1',
        id: 0
      }, {
        imgPath: '',
        title: '模板2',
        id: 0
      }, {
        imgPath: '',
        title: '模板3',
        id: 0
      }, {
        imgPath: '',
        title: '模板4',
        id: 0
      }, {
        imgPath: '',
        title: '模板5',
        id: 0
      }],
      viewCount: 0,
      sectionStatus: 0,
      pointIcondisabled: false
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    'ispc'(val) {
      let map_center = !val ? this.form.map_center.split(',') : this.form.app_map_center.split(',');
      // console.log(map_center)
      this.form.map_centerX = parseInt(map_center[0]);
      this.form.map_centerY = parseInt(map_center[1]);
    }
  },
  methods: {
    // 初始化操作
    init() {
      this.getMapconfigStruct();
    },
    // 获取地图管理结构数据
    getMapconfigStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 177623
      };
      this.$api.formStruct(params).then(res => {
        this.structList = JSON.parse(JSON.stringify(res));
        this.sList = this.getformatstruct(res);
        // console.log(this.sList)
        // this.form.title_font = 'bold 14px 微软雅黑'
        // 初始化form值
        this.form.dotimgW = Number(this.form.dotimgW);
        this.form.appimgW = Number(this.form.appimgW);
        this.form.pointIcon = '否';
        this.pointIcondisabled = this.form.pointIcon = '否';
        this.form.pointImg = '是';
        this.form.title_mtp = 32;
        console.log(this.form);
        // console.log(this.formoption)
        this.getMapconfig();
        // console.log(recordparams.value)
      });
    },
    // 获取地图配置表单数据
    getMapconfig() {
      let _this = this;
      let params = {
        deptId: this.$route.query.fid,
        formId: 177623,
        formUserId: this.$route.query.formUserId
      };
      this.$api.singleformUserId(params.deptId, params.formId, params.formUserId).then(res => {
        // console.log(res.formUserList)
        // 若有数据 走编辑
        if (res.formUserList.length > 0) {
          this.isAddOrEdit = false;
          this.currentformuser = res.formUserList[0];
          let dataUser = res.formUserList[0].formData;
          dataUser.forEach(item => {
            this.form[item.alias] = this.getformdata(item);
            if (getFileStatus(item)) {
              this.dfileList[item.alias] = item.values.length > 0 ? this.getfileformatForm(item.values) : [];
              this.fileList[item.alias] = item.values;
            }
          });
          if (this.form.mapmodetype === '切片地图') this.sectionStatus = 1;
          // console.log(this.currentformuser)
          // 判断是否有jsontxt样式参数
          if (this.form.jsontxt && this.form.jsontxt !== '') {
            this.jsonOption = JSON.parse(this.getStr(this.form.jsontxt));
            console.log(this.jsonOption);
            if (this.jsonOption.point) {
              Object.keys(this.jsonOption.point).forEach(item => {
                this.form[item] = this.jsonOption.point[item];
              });
              this.pointIcondisabled = this.form.pointIcon === '否';
            }
            if (this.jsonOption.type) {
              console.log(this.jsonOption.type);
              Object.keys(this.jsonOption.type).forEach(item => {
                this.form[`type${item}`] = this.jsonOption.type[item];
              });
              if (this.jsonOption.type.typeflag) this.form.typeflag = this.jsonOption.type.typeflag;
            }
            if (this.jsonOption.map) {
              Object.keys(this.jsonOption.map).forEach(item => {
                this.form[`${item}`] = this.jsonOption.map[item];
              });
            }
            if (this.jsonOption.footerinfo) {
              this.form.copyright = this.jsonOption.footerinfo.copyright;
              this.form.viewflag = this.jsonOption.footerinfo.viewflag ? '是' : '否';
              this.form.viewplus = this.jsonOption.footerinfo.viewplus;
              this.viewCount = this.jsonOption.footerinfo.viewCount;
            }
          }
          // this.mapconfigData = JSON.parse(JSON.stringify(this.form))
          // console.log(this.form)
          // console.log(this.jsonOption)
          let map_center = !this.ispc ? this.form.map_center.split(',') : this.form.app_map_center.split(',');
          // console.log(map_center)
          this.form.map_centerX = Number(map_center[0]);
          this.form.map_centerY = Number(map_center[1]);
          this.form.dotimgW = Number(this.form.dotimgW);
          this.form.appimgW = Number(this.form.appimgW);
          this.getleveloptions();
          let obj = {
            form: this.form,
            update: true,
            jsonOption: this.jsonOption,
            item: this.currentformuser
          };
          this.$emit('updateMap', obj);
          // _this.map = null
          // document.querySelector('.map_content').innerHTML = ''
          // _this.$nextTick(() => {
          //   _this.staticmap()
          //   // _this.getData()
          // })
          console.log(this.form);
        } else {
          this.isAddOrEdit = true;
        }
        this.$emit('isAddOrEdit', this.isAddOrEdit);
      });
    },
    basicHandle() {
      if (this.form.title === '') {
        ElMessage.error('请输入地图名称');
        return;
      }
      if (this.form.toptitle === '') {
        ElMessage.error('请输入头部标题');
        return;
      }
      if (this.sectionStatus === 0) {
        if (this.fileList.static_img.length === 0 || this.fileList.static_img === undefined) {
          ElMessage.error('请上传静态地图图片');
          return;
        }
      }
      this.submitdataHandle();
      // this.typeFlag = true
      // this.stepIndex = 1
    },
    getStr(str) {
      return str.replace(/(<\/?p.*?>)/gi, '');
    },
    // 表单无数据返回空
    getformdata(data) {
      let typekey = 'val';
      if (!data.values) return '';
      if (!data.values[0]) return '';
      let valuesdata = data.values[0];
      if (data.compt === 'imagebox') return valuesdata;
      return valuesdata[typekey] !== '' ? valuesdata[typekey] : '';
    },
    blurInput(val, name, type) {
      console.log(1111111111);
      console.log(val);
      console.log(name);
      if (name === 'toptitle') document.title = val;
      // this.mapconfigData[name] = val.target ? val.target.value : val
      if (name === 'static_map_min_level' && this.form.static_map_max_level !== '' && parseInt(this.form.static_map_min_level) > parseInt(this.form.static_map_max_level)) {
        ElMessage({
          message: '请最小层级小于最大层级',
          type: 'warning'
        });
        return;
      }
      if (name === 'static_map_max_level' && this.form.static_map_min_level !== '' && parseInt(this.form.static_map_min_level) > parseInt(this.form.static_map_max_level)) {
        ElMessage({
          message: '请最大层级大于最小层级',
          type: 'warning'
        });
        return;
      }
      if (name === 'current_level' && this.form.static_map_min_level === '' && this.form.static_map_max_level === '') {
        ElMessage({
          message: '未选择最大层级或最小层级',
          type: 'warning'
        });
        return;
      } else {
        this.getleveloptions();
      }
      if (name === 'map_center' && !this.ispc) this.form.map_center = this.form.map_centerX + ',' + this.form.map_centerY;
      if (name === 'app_map_center' && this.ispc) this.form.app_map_center = this.form.map_centerX + ',' + this.form.map_centerY;
      if (name === 'mapmodetype') {
        this.sectionStatus = this.form.mapmodetype === '切片地图' ? 1 : 0;
      }
      let obj = {
        form: this.form,
        update: false,
        jsonOption: this.jsonOption
      };
      this.$emit('updateMap', obj);
    },
    getleveloptions() {
      this.leveloptions = [];
      let min = this.sectionStatus === 0 ? Math.floor(this.form.static_map_min_level) : Math.floor(this.form.map_min_level);
      let max = this.sectionStatus === 0 ? Math.ceil(this.form.static_map_max_level) : Math.ceil(this.form.map_max_level);
      // console.log(min)
      // console.log(max)
      let len = max > 10 ? max : max - min + 1;
      // console.log(`len:${len}`)
      if (len > 0) {
        for (let i = min; i <= len; i++) {
          this.leveloptions.push({
            title: i
          });
          if (i + 1 <= len) {
            for (let j = 1; j < 10; j++) {
              this.leveloptions.push({
                title: i + j * 0.1
              });
            }
          }
        }
      } else {
        this.leveloptions = [{
          title: this.form.static_map_min_level
        }];
      }
      this.$emit('leveloptions', this.leveloptions);
    },
    // 上传文件点击事件 确定传哪个文件字段
    uploadClick(val) {
      this.cfname = val;
    },
    // 上传文件
    uploadChange(rawFile) {
      console.log(rawFile);
      let formData = new FormData();
      formData.append('file', rawFile.raw);
      formData.append('_uid', this.$route.query.uid);
      formData.append('fid', this.$route.query.fid);
      this.$api.uploadSingle(formData).then(res => {
        res.url = handleHttp(res.http);
        let fdata = this.fileList[this.cfname];
        fdata && fdata.length > 0 ? this.fileList[this.cfname].push(res) : this.fileList[this.cfname] = [res];
        console.log(this.fileList[this.cfname]);
        this.form[this.cfname] = handleHttp(res.http);
        let obj = {
          form: this.form,
          update: false,
          jsonOption: this.jsonOption
        };
        this.$emit('updateMap', obj);
      });
    },
    // 删除图片文件操作
    handleRemove(file, name) {
      console.log(file);
      this.fileList[name] = this.fileList[name].filter(elem => {
        return elem.name !== file.name;
      });
      this.dfileList[name] = JSON.parse(JSON.stringify(this.fileList[name]));
      this.form[name] = '';
      console.log(this.fileList[name]);
      console.log(this.dfileList[name]);
      let obj = {
        form: this.form,
        update: false,
        jsonOption: this.jsonOption
      };
      this.$emit('updateMap', obj);
    },
    handleExceed(val) {
      console.log(this.cfname);
      console.log(val);
    },
    getformatstruct(data) {
      return data.map(i => {
        this.form[i.alias] = '';
        // 表单字段名称
        this.formlabel[i.alias] = i.label;
        // 表单字段默认值处理
        if (i.field.options) {
          this.formoption[i.alias] = i.field.options;
        }
        if (i.field.defaultValueStr) {
          let idStr = i.field.defaultValueStr;
          if (idStr) {
            let dStr = idStr === '[]' ? '' : JSON.parse(idStr);
            this.form[i.alias] = dStr !== '' ? dStr[0].val : '';
          }
        }
        let itemObj = {
          alias: i.alias,
          compt: i.compt,
          values: getFileStatus(i) ? [] : [{
            val: ''
          }]
        };
        return itemObj;
      });
    },
    // 添加/编辑地图管理数据
    submitdataHandle() {
      let formData = {
        deptId: this.$route.query.fid,
        formId: this.currentformuser.formId,
        formUserId: this.$route.query.formUserId
      };
      let dataList = JSON.parse(JSON.stringify(this.sList));
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.fileList['background_img'] === undefined) {
            ElNotification({
              message: '请上传电脑端背景图片',
              type: 'warning'
            });
            return;
          }
          // 点位相关字段集合
          this.jsonOption.point = {
            title_bgcolor: this.form.title_bgcolor ? this.form.title_bgcolor : '',
            title_bocolor: this.form.title_bocolor ? this.form.title_bocolor : '',
            title_color: this.form.title_color ? this.form.title_color : '',
            title_font: this.form.title_font ? this.form.title_font : '',
            pointIcon: this.form.pointIcon,
            pointImg: this.form.pointImg,
            title_mtp: this.form.title_mtp,
            location_title: this.form.location_title,
            dotimgW: this.form.dotimgW,
            appimgW: this.form.appimgW
          };
          // 类型
          this.jsonOption.type = {
            model: this.form.typemodel || '模板1',
            orderBy: this.form.typeorderBy,
            orderType: this.form.typeorderType,
            typeflag: this.form.typeflag
          };
          // 地图配置项
          this.jsonOption.map = {
            dragazoom: this.form.dragazoom,
            dragrotate: this.form.dragrotate
          };
          // 底部信息配置项
          this.jsonOption.footerinfo = {
            copyright: '',
            viewflag: false,
            viewCount: this.viewCount,
            viewplus: 0
          };
          let copyright = document.querySelector('.introduce').innerHTML;
          if (copyright !== '') this.jsonOption.footerinfo.copyright = copyright;
          if (this.form.viewflag !== undefined) this.jsonOption.footerinfo.viewflag = this.form.viewflag === '是' ? true : false;
          if (this.form.viewplus !== undefined) this.jsonOption.footerinfo.viewplus = this.form.viewplus === '' ? 0 : this.form.viewplus;
          dataList = dataList.map(item => {
            let v = this.form[item.alias];
            // 先统一处理下form字段值
            if (v === '' || v.length === 0) v = '';
            if (v.length === 1 && v[0].val === '') v = '';
            item.values = v;
            // 处理文件字段赋值
            if (getFileStatus(item)) {
              let filedata = '';
              Object.keys(this.fileList).forEach(elem => {
                if (elem === item.alias) filedata = this.fileList[elem];
              });
              if (filedata === '') return item;
              item.values = formfileHandle(filedata, item.compt, this.$route.query.uid);
            }
            // 处理地图中心坐标问题
            let mpX = this.form.map_centerX ? Number(this.form.map_centerX) : 240;
            let mpY = this.form.map_centerY ? Number(this.form.map_centerY) : 240;
            if (item.alias === 'map_center' && !this.ispc) item.values = mpX + ',' + mpY;
            if (item.alias === 'app_map_center' && this.ispc) item.values = mpX + ',' + mpY;
            if (item.compt === 'richtext') {
              item.values = '<p element-id=\"init\" style="display: none;">' + JSON.stringify(this.jsonOption) + '</p>';
            }
            return item;
          });
          dataList = dataList.filter(item => {
            return item.values !== '';
          });
          dataList = dataList.map(item => {
            if (item.compt !== 'imagebox' && item.compt !== 'videobox' && item.compt !== 'location' && item.compt !== 'fileupload') {
              item.values = [{
                val: item.values
              }];
            }
            return item;
          });
          let _this = this;
          if (!this.isAddOrEdit) {
            this.$api.editForm(formData.deptId, formData.formUserId, encodeURI(JSON.stringify(dataList)), formData.formId).then(res => {
              console.log(res);
              ElNotification({
                message: '更新成功',
                type: 'success'
              });
              let obj = {
                form: _this.form,
                update: false,
                jsonOption: this.jsonOption
              };
              _this.$emit('updateMap', obj);
            });
          }
        }
      });
    },
    // 获取文件路径（无fileUrl, 依据objectId)
    getfileformatForm(data) {
      // console.log(data)
      return data.map(item => {
        item.url = item.fileUrl;
        if (!item.fileUrl) {
          this.$api.getUrlByObjectId(item.objectId).then(res => {
            item.url = handleHttp(res.http);
          });
        }
        return item;
      });
    },
    // 点位图标改变事件
    pointIconChange(val) {
      console.log(val);
      this.pointIcondisabled = val === '是' ? false : true;
    }
  }
};